import { render } from "./ChangeLogin.vue?vue&type=template&id=6c0ac0c0"
import script from "./ChangeLogin.vue?vue&type=script&lang=js"
export * from "./ChangeLogin.vue?vue&type=script&lang=js"

import "./ChangeLogin.vue?vue&type=style&index=0&id=6c0ac0c0&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__